//      
import {                                        } from 'css-box-model';
import { subtract } from '../../position';
import { offsetByPosition } from '../../spacing';
import {
  isTotallyVisible,
  isTotallyVisibleOnAxis,
                             
} from '../../visibility/is-visible';
                                                                             

              
                                
                                  
                                   
                 
                                                     
                                   
                           
   

export default ({
  draggable,
  destination,
  newPageBorderBoxCenter,
  viewport,
  withDroppableDisplacement,
  onlyOnMainAxis = false,
}      )          => {
  // What would the location of the Draggable be once the move is completed?
  // We are not considering margins for this calculation.
  // This is because a move might move a Draggable slightly outside of the bounds
  // of a Droppable (which is okay)
  const changeNeeded           = subtract(
    newPageBorderBoxCenter,
    draggable.page.borderBox.center,
  );
  const shifted          = offsetByPosition(
    draggable.page.borderBox,
    changeNeeded,
  );

  // Must be totally visible, not just partially visible.
  const args                = {
    target: shifted,
    destination,
    withDroppableDisplacement,
    viewport,
  };

  return onlyOnMainAxis ? isTotallyVisibleOnAxis(args) : isTotallyVisible(args);
};



// WEBPACK FOOTER //
// ./src/components/react-beautiful-dnd/state/move-in-direction/move-to-next-place/is-totally-visible-in-new-location.js